
export const fieldsInfo: any = {
  // fields with half cell size
  halfSizeFields: [
    'parent.name',
    'parent_gln',
    'parent_duns',
    'parent_vmrs',
    'owner.name',
    'owner_gln',
    'owner_duns',
    'owner_vmrs',
    'brand.name',
    'brand_gln',
    'brand_duns',
    'brand_vmrs',
  ],

  // input fields
  inputFields: [
    'parent_gln',
    'parent_duns',
    'parent_vmrs',
    'owner_gln',
    'owner_duns',
    'owner_vmrs',
    'brand_gln',
    'brand_duns',
    'brand_vmrs',
  ],

  // paragraphs
  readonlyFields: [
    'parent.name',
    'owner.name',
    'brand.name',
  ],

};
